import { render, staticRenderFns } from "./the-sms-dialog.vue?vue&type=template&id=5195adf5&scoped=true&"
import script from "./the-sms-dialog.vue?vue&type=script&lang=js&"
export * from "./the-sms-dialog.vue?vue&type=script&lang=js&"
import style0 from "./the-sms-dialog.vue?vue&type=style&index=0&id=5195adf5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5195adf5",
  null
  
)

export default component.exports